import { OnInit, Directive } from '@angular/core';
import * as _ from 'lodash';
import { BaseService } from './baseService';

@Directive()
export class BasePlugin extends BaseService implements OnInit {
  constructor() {
    super();
  }
  public getValueByIndex(array: any, index: any): string {
    return array[index];
  }

  getValue(value: any, array: any): string {
    const obj = _.find(array, ['value', value]);
    return obj ? obj.label : '';
  }

  getIcon(value: any, array: any): string {
    const obj = _.find(array, ['value', value]);
    return obj ? obj.icon : '';
  }

  ngOnInit(): void {}
}
